import * as t from 'ts-codec';

export const UpdateDetailsRequest = t.object({
  name: t.string
});
export type UpdateDetailsRequest = t.Encoded<typeof UpdateDetailsRequest>;
